import { GetStaticProps, GetStaticPropsContext } from 'next';

import { NewsletterSubscription } from '@/utils/functions/subscribe-to-newsletter';
import fetchBeehiivPosts from '@/utils/functions/beehiiv/fetch-beehiiv-posts';
import EditorialConfig from '@/editorial-config';

export const newsletterMeta: { [key: string]: any } = {
    daily: {
        title: 'Blockworks Daily',
        description:
            'The newsletter that helps thousands of investors understand crypto and the markets, by Byron Gilliam.',
        og_image: [
            {
                width: 1330,
                height: 912,
                type: 'image/jpeg',
                url: 'https://cms.blockworks.co/wp-content/uploads/2021/01/Blockworks_Newsletter_2.jpg?20221121',
            },
        ],
        twitter_card: 'summary_large_image',
        key: NewsletterSubscription.Daily,
        postArchive: true,
    },
    weekly: {
        title: 'Blockworks Weekly',
        description:
            'The newsletter that helps thousands of investors understand crypto and the markets - Delivered weekly.',
        og_image: [
            {
                width: 1330,
                height: 912,
                type: 'image/jpeg',
                url: 'https://cms.blockworks.co/wp-content/uploads/2021/01/Blockworks_Newsletter_2.jpg?20221121',
            },
        ],
        twitter_card: 'summary_large_image',
        key: NewsletterSubscription.Weekly,
        postArchive: true,
    },
    research: {
        title: '0x Research',
        description:
            'Alpha directly in your inbox, including market highlights, charts, degen trade ideas, governance updates, token performance, can’t-miss-tweets and more, by Blockworks Research.',
        og_image: [
            {
                width: 1330,
                height: 912,
                type: 'image/jpeg',
                url: 'https://cms.blockworks.co/wp-content/uploads/2021/01/Blockworks_Newsletter_2.jpg?20221121',
            },
        ],
        twitter_card: 'summary_large_image',
        key: NewsletterSubscription.ResearchDaily,
        postArchive: true,
    },
    empire: {
        title: 'The Empire Newsletter',
        description:
            'Start your morning with the top news, analysis and data to inform your day in crypto, by the Blockworks News team.',
        og_image: [
            {
                type: 'image/png',
                url: `${EditorialConfig.SITE_URL}/images/newsletter/EmpireOG.png`,
            },
        ],
        twitter_card: 'summary_large_image',
        key: NewsletterSubscription.Empire,
        postArchive: false,
    },
    lightspeed: {
        title: 'Lightspeed Newsletter',
        description:
            "A daily newsletter built for Solana investors, developers and community members. The latest news, analysis and data from one of crypto's hottest networks.",
        og_image: [
            {
                type: 'image/png',
                url: `${EditorialConfig.SITE_URL}/images/newsletter/Lightspeed_NewsletterPage_Thumb_20240520a.png`,
            },
        ],
        twitter_card: 'summary_large_image',
        key: NewsletterSubscription.Lightspeed,
        postArchive: false,
    },
    onthemargin: {
        title: 'On The Margin Newsletter',
        description:
            'Daily reporting, analysis and more on the growing intersection between crypto and macroeconomics, policy and finance.',
        og_image: [
            {
                type: 'image/png',
                url: `${EditorialConfig.SITE_URL}/images/newsletter/OTM_NewsletterPage_Thumb_20240520a.png`,
            },
        ],
        twitter_card: 'summary_large_image',
        key: NewsletterSubscription.OnTheMargin,
        postArchive: false,
    },
};
export const NewsletterPublicationStaticProps: GetStaticProps = async (context: GetStaticPropsContext) => {
    const slug: string = context.params?.slug as string;
    if (!slug) {
        return {
            notFound: true,
            revalidate: 600,
        };
    }

    const latest =
        newsletterMeta[slug].postArchive === true
            ? await fetchBeehiivPosts(newsletterMeta[slug].key ?? NewsletterSubscription.Daily)
            : null;

    return {
        props: {
            meta: newsletterMeta[slug] ?? null,
            latest,
        },
        revalidate: 1800,
    };
};

export default NewsletterPublicationStaticProps;
